import React, { useState } from 'react';
import './MalaysianUniversitiesPage.css';

const universities = [
  { id: 1, name: 'INTI University', location: 'Nilai, NS', type: 'Private', focus: 'Business, Engineering, IT', website: 'https://www.newinti.edu.my', emoji: '🎓' },
  { id: 2, name: 'SEGi University', location: 'Kota Damansara', type: 'Private', focus: 'Health Sciences, Business', website: 'https://www.segi.edu.my', emoji: '🎓' },
  { id: 3, name: 'Asia Pacific University (APU)', location: 'Bukit Jalil, KL', type: 'Private', focus: 'Technology, Computing', website: 'https://www.apu.edu.my', emoji: '💻' },
  { id: 4, name: 'LSBF College Malaysia', location: 'Kuala Lumpur', type: 'Private', focus: 'Business, Finance', website: 'https://www.lsbf.edu.my', emoji: '💼' },
  { id: 5, name: 'University of Cyberjaya', location: 'Cyberjaya', type: 'Private', focus: 'Health Sciences, IT', website: 'https://www.cyberjaya.edu.my', emoji: '🏥' },
  { id: 6, name: 'UniKL University', location: 'Kuala Lumpur', type: 'Private', focus: 'Engineering, Technology', website: 'https://www.unikl.edu.my', emoji: '⚙️' },
  { id: 7, name: 'UCMI University', location: 'Kuala Lumpur', type: 'Private', focus: 'Management, Commerce', website: 'https://www.ucmi.edu.my', emoji: '📊' },
  { id: 8, name: 'KL University of Science & Technology (KLUSt)', location: 'Kuala Lumpur', type: 'Private', focus: 'Science, Technology', website: 'https://www.klust.edu.my', emoji: '🔬' },
  { id: 9, name: 'UNITEN University', location: 'Kajang, Selangor', type: 'Private', focus: 'Engineering, Energy', website: 'https://www.uniten.edu.my', emoji: '⚡' },
  { id: 10, name: 'Asia e University', location: 'Kuala Lumpur', type: 'Private', focus: 'Online & Distance Learning', website: 'https://www.aeu.edu.my', emoji: '🌐' },
  { id: 11, name: 'ALFA University & College', location: 'Kuala Lumpur', type: 'Private', focus: 'Business, Arts', website: 'https://www.alfa.edu.my', emoji: '🎨' },
  { id: 12, name: 'Nilai University', location: 'Nilai, NS', type: 'Private', focus: 'Business, Hospitality', website: 'https://www.nilai.edu.my', emoji: '🍽️' },
  { id: 13, name: 'MILA University', location: 'Malaysia', type: 'Private', focus: 'Liberal Arts, Management', website: 'https://www.mila.edu.my', emoji: '📚' },
  { id: 14, name: 'Lincoln University College', location: 'Petaling Jaya', type: 'Private', focus: 'Health Sciences, Business', website: 'https://www.lincoln.edu.my', emoji: '🏛️' },
  { id: 15, name: 'MAHSA University', location: 'Bandar Saujana Putra', type: 'Private', focus: 'Health Sciences, Medicine', website: 'https://www.mahsa.edu.my', emoji: '🩺' },
  { id: 16, name: 'UniMY University', location: 'Cyberjaya', type: 'Private', focus: 'Media, Communication', website: 'https://www.unimy.edu.my', emoji: '📡' },
  { id: 17, name: 'Veritas University College', location: 'Kuala Lumpur', type: 'Private', focus: 'Creative Arts, Media', website: 'https://www.veritas.edu.my', emoji: '🎭' },
  { id: 18, name: 'Reliance College', location: 'Kuala Lumpur', type: 'Private', focus: 'Business, Foundation', website: 'https://www.reliance.edu.my', emoji: '📖' },
  { id: 19, name: 'YPC International College', location: 'Kuala Lumpur', type: 'Private', focus: 'IT, Business', website: 'https://www.ypc.edu.my', emoji: '💡' },
  { id: 20, name: 'IACT College', location: 'Subang Jaya', type: 'Private', focus: 'Creative Media, Communication', website: 'https://www.iact.edu.my', emoji: '🎬' },
  { id: 21, name: 'UTM SPACE', location: 'Kuala Lumpur', type: 'Public', focus: 'Engineering, Technology', website: 'https://space.utm.my', emoji: '🚀' },
  { id: 22, name: 'AMU University', location: 'Malaysia', type: 'Private', focus: 'Management, Business', website: 'https://www.amu.edu.my', emoji: '🎓' },
  { id: 23, name: 'University of Malaya Wales', location: 'Kuala Lumpur', type: 'Private', focus: 'Business, Law', website: 'https://www.umw.edu.my', emoji: '⚖️' },
  { id: 24, name: 'Xiamen University Malaysia', location: 'Sepang, Selangor', type: 'Private', focus: 'Business, Chinese Studies', website: 'https://www.xmu.edu.my', emoji: '🏮' },
  { id: 25, name: 'UPTM University', location: 'Kuala Lumpur', type: 'Private', focus: 'Technology, Management', website: 'https://www.uptm.edu.my', emoji: '🔧' },
  { id: 26, name: 'UiTM University', location: 'Shah Alam', type: 'Public', focus: 'Various Disciplines', website: 'https://www.uitm.edu.my', emoji: '🎓' },
  { id: 27, name: 'UniRazzak University', location: 'Kuala Lumpur', type: 'Private', focus: 'Islamic Finance, Management', website: 'https://www.unirazzak.edu.my', emoji: '🌙' },
  { id: 28, name: 'UNITAR University', location: 'Kelana Jaya', type: 'Private', focus: 'Business, IT, Education', website: 'https://www.unitar.my', emoji: '📋' },
  { id: 29, name: 'UTAR University', location: 'Kampar, Perak', type: 'Private', focus: 'Engineering, Science, Business', website: 'https://www.utar.edu.my', emoji: '⚗️' },
  { id: 30, name: 'City University Malaysia', location: 'Petaling Jaya', type: 'Private', focus: 'Business, Engineering', website: 'https://www.city.edu.my', emoji: '🏙️' },
  { id: 31, name: 'Limkokwing University', location: 'Cyberjaya', type: 'Private', focus: 'Creative Technology, Design', website: 'https://www.limkokwing.edu.my', emoji: '🎨' },
  { id: 32, name: 'MMU University', location: 'Cyberjaya', type: 'Private', focus: 'Multimedia, Engineering, IT', website: 'https://www.mmu.edu.my', emoji: '📱' },
  { id: 33, name: 'UCYP University', location: 'Malaysia', type: 'Private', focus: 'Business, Technology', website: 'https://www.ucyp.edu.my', emoji: '🎓' },
  { id: 34, name: 'UniSZA University', location: 'Terengganu', type: 'Public', focus: 'Islamic Studies, Sciences', website: 'https://www.unisza.edu.my', emoji: '🕌' },
  { id: 35, name: 'UNISEL University', location: 'Shah Alam', type: 'Private', focus: 'Business, Engineering', website: 'https://www.unisel.edu.my', emoji: '🏗️' },
  { id: 36, name: 'Perdana University', location: 'Kuala Lumpur', type: 'Private', focus: 'Medicine, Health Sciences', website: 'https://www.perdanauniversity.edu.my', emoji: '🩺' },
  { id: 37, name: 'SAITO University College', location: 'Kuala Lumpur', type: 'Private', focus: 'Design, Business, Management', website: 'https://www.saito.edu.my', emoji: '✏️' },
  { id: 38, name: 'IMU University', location: 'Bukit Jalil, KL', type: 'Private', focus: 'Medicine, Health Sciences', website: 'https://www.imu.edu.my', emoji: '⚕️' },
  { id: 39, name: 'Berjaya University College', location: 'Kuala Lumpur', type: 'Private', focus: 'Hospitality, Culinary, Business', website: 'https://www.berjaya.edu.my', emoji: '🍴' },
  { id: 40, name: 'IIUM University', location: 'Gombak, Selangor', type: 'Public', focus: 'Islamic Studies, Law, Engineering', website: 'https://www.iium.edu.my', emoji: '🕌' },
  { id: 41, name: 'Binary University', location: 'Puchong, Selangor', type: 'Private', focus: 'Technology, Entrepreneurship', website: 'https://www.binary.edu.my', emoji: '💻' },
  { id: 42, name: 'ELMU University', location: 'Kuala Lumpur', type: 'Private', focus: 'Health Sciences, Pharmacy', website: 'https://www.elmu.edu.my', emoji: '💊' },
  { id: 43, name: 'IIMAT College', location: 'Kuala Lumpur', type: 'Private', focus: 'IT, Management', website: 'https://www.iimat.edu.my', emoji: '💻' },
  { id: 44, name: 'Kings University College', location: 'Kuala Lumpur', type: 'Private', focus: 'Business, Hospitality', website: 'https://www.kingsuniversity.edu.my', emoji: '👑' },
  { id: 45, name: 'Spectrum University College', location: 'Kuala Lumpur', type: 'Private', focus: 'Business, IT', website: 'https://www.spectrum.edu.my', emoji: '🌈' },
  { id: 46, name: 'University of Wollongong Malaysia', location: 'Kuala Lumpur', type: 'Private', focus: 'Engineering, Business', website: 'https://www.uow.edu.my', emoji: '🦘' },
  { id: 47, name: "Taylor's University", location: 'Subang Jaya', type: 'Private', focus: 'Hospitality, Business, Law', website: 'https://www.taylors.edu.my', emoji: '⭐' },
  { id: 48, name: 'MSU University', location: 'Shah Alam', type: 'Private', focus: 'Health Sciences, Engineering', website: 'https://www.msu.edu.my', emoji: '🔬' },
  { id: 49, name: 'Sunway University', location: 'Bandar Sunway', type: 'Private', focus: 'Business, Computing, Health', website: 'https://www.sunway.edu.my', emoji: '☀️' },
  { id: 50, name: 'UCSI University', location: 'Cheras, KL', type: 'Private', focus: 'Medicine, Music, Engineering', website: 'https://www.ucsiuniversity.edu.my', emoji: '🎵' },
  { id: 51, name: 'Heriot-Watt University Malaysia', location: 'Putrajaya', type: 'Private', focus: 'Engineering, Business, Design', website: 'https://www.hw.ac.uk/malaysia', emoji: '🏴󠁧󠁢󠁳󠁣󠁴󠁿' },
  { id: 52, name: 'Monash University Malaysia', location: 'Bandar Sunway', type: 'Private', focus: 'Engineering, Business, Medicine', website: 'https://www.monash.edu.my', emoji: '🦁' },
];

const typeColors = {
  'Public': '#2ec97e',
  'Private': '#d4a843',
};

export default function MalaysianUniversitiesPage() {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('All');

  const filtered = universities.filter(u => {
    const matchType = filter === 'All' || u.type === filter;
    const q = search.toLowerCase();
    const matchSearch = u.name.toLowerCase().includes(q) || u.focus.toLowerCase().includes(q) || u.location.toLowerCase().includes(q);
    return matchType && matchSearch;
  });

  return (
    <div className="my-page">
      <div className="my-hero">
        <div className="my-hero-inner">
          <span className="section-tag">Study in Malaysia</span>
          <h1 className="my-hero-title">Malaysian <span className="gold-text">Universities</span></h1>
          <p className="my-hero-sub">
            Explore our complete list of 52 partner universities in Malaysia. Click any university to visit their official website and learn more about programmes, fees and admissions.
          </p>
          <div className="my-stats-row">
            <div className="my-stat"><span className="my-stat-num">52</span><span className="my-stat-label">Partner Universities</span></div>
            <div className="my-stat"><span className="my-stat-num">500+</span><span className="my-stat-label">Programmes</span></div>
            <div className="my-stat"><span className="my-stat-num">100%</span><span className="my-stat-label">Accredited</span></div>
          </div>
        </div>
      </div>

      <div className="my-body">
        <div className="my-filters">
          <div className="my-search-wrap">
            <span className="search-icon">🔍</span>
            <input
              type="text"
              placeholder="Search by name, course, or location..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="my-search"
            />
          </div>
          <div className="my-filter-btns">
            {['All', 'Private', 'Public'].map(t => (
              <button
                key={t}
                className={`filter-btn ${filter === t ? 'active' : ''}`}
                onClick={() => setFilter(t)}
              >
                {t} {t !== 'All' && `(${universities.filter(u => u.type === t).length})`}
              </button>
            ))}
          </div>
          <div className="my-result-count">
            Showing <strong>{filtered.length}</strong> of {universities.length} universities
          </div>
        </div>

        <div className="uni-grid">
          {filtered.map((u, i) => (
            <a
              key={u.id}
              href={u.website}
              target="_blank"
              rel="noopener noreferrer"
              className="uni-card"
              style={{ animationDelay: `${i * 0.03}s` }}
            >
              <div className="uni-card-top">
                <div className="uni-num">#{u.id}</div>
                <span className="uni-type" style={{ background: typeColors[u.type] + '22', color: typeColors[u.type], border: `1px solid ${typeColors[u.type]}44` }}>
                  {u.type}
                </span>
              </div>
              <div className="uni-emoji">{u.emoji}</div>
              <h3 className="uni-name">{u.name}</h3>
              <div className="uni-location">📍 {u.location}</div>
              <div className="uni-focus">🎯 {u.focus}</div>
              <div className="uni-cta">
                Visit Website <span>→</span>
              </div>
            </a>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="no-results">
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>🔎</div>
            <h3>No universities found</h3>
            <p>Try a different search term or filter</p>
            <button onClick={() => { setSearch(''); setFilter('All'); }} className="btn-primary" style={{ marginTop: '16px', padding: '10px 24px', borderRadius: '50px', background: 'var(--gold)', color: 'var(--navy)', border: 'none', cursor: 'pointer', fontWeight: '700' }}>
              Clear Filters
            </button>
          </div>
        )}

        <div className="my-cta-section">
          <div className="my-cta-inner">
            <h2>Not Sure Which University to Choose?</h2>
            <p>Our expert counsellors will help you find the perfect match based on your goals, budget and course preferences — completely free!</p>
            <a href="https://wa.me/601169479883?text=Hi! I need help choosing a Malaysian university." target="_blank" rel="noopener noreferrer" className="cta-wa-btn">
              💬 Chat on WhatsApp
            </a>
            <a href="mailto:studiline.bd@gmail.com" className="cta-email-btn">
              📧 Email Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
